import { createSelector } from 'reselect';

const selectDomain = (state) => state.retreatButton;

export const selectRetreating = createSelector(
  [selectDomain], (state) => state.get('retreating'),
);

export const selectRetreatFlowing = createSelector(
  [selectDomain], (state) => state.get('retreatFlowing'),
);

export const selectChoosingEnergies = createSelector(
  [selectDomain], (state) => state.get('choosingEnergies'),
);

export const selectEnergyAttachmentIds = createSelector(
  [selectDomain], (state) => state.get('energyAttachmentIds'),
);

export const selectChoosingBenchPosition = createSelector(
  [selectDomain], (state) => state.get('choosingBenchPosition'),
);

export const selectBenchPosition = createSelector(
  [selectDomain], (state) => state.get('benchPosition'),
);
export const selectChosenBenchPosition = createSelector(
  [selectDomain], (state) => state.get('chosenBenchPosition'),
);
